import exp from "constants";
import Config from '../config.json';

export type Configuration = {
    CDN_URL: string;
    API_URL: string;
    API_KEY: string;
    B2C_Tenant: string;
    B2C_EndPoint: string;
    B2C_ClientId: string;
    B2C_Scope: string;
    RTEDITOR_TOOLBAR:string;
};

const conf = (Config as unknown as Configuration)
export function cdnEndPoint() {
    return (
        (conf.CDN_URL)
    );
}
export function rtEditorToolbar(){
    return  conf.RTEDITOR_TOOLBAR;
}
export function apiEndPoint(){
    return  conf.API_URL;
}
export function apiKey(){
    return conf.API_KEY;
}
export function b2cTenant(){
    let tenant: string = conf.B2C_Tenant === undefined ? "" : conf.B2C_Tenant;
    return tenant;
}
export function b2cAuthorityDomain(){
    let authorityDomain: string = conf.B2C_Tenant === undefined ? "" : conf.B2C_Tenant;
    return `${authorityDomain}.b2clogin.com`;
}
export function b2cEndPoint(){
    let b2cEndPointString: string =  conf.B2C_EndPoint === undefined ? "" : conf.B2C_EndPoint;
    return b2cEndPointString;
}
export function b2cClientId(){
    let clientId: string = conf.B2C_ClientId === undefined ? "" : conf.B2C_ClientId;
    return clientId;
}
export function b2cScopeEndPoint(){
    let scope: string = conf.B2C_Scope === undefined ? "" : conf.B2C_Scope;
    return scope;
}
export function b2cSignInAuthority(){
    let endPoint : string = b2cEndPoint();
    return `https://${b2cTenant()}.b2clogin.com/${b2cTenant()}.onmicrosoft.com/${endPoint}`;
}